import { Directive, ElementRef } from '@angular/core';

/**
 * Marks the element inside an `[nxReorderItem]` that initiates the drag
 * (equivalent to `cdkDragHandle`). Optional — without it the whole row drags.
 */
@Directive({
  selector: '[nxReorderHandle]'
})
export class NxReorderHandleDirective {
  constructor(public readonly elementRef: ElementRef<HTMLElement>) {}
}
